/*
 * Live åbne/lukket-status for support-blokken (footer + kontaktside).
 * Læser sin konfiguration fra [data-fs-config] i hver blok, så samme fil kan
 * betjene flere blokke på samme side. Se snippets/support-block.liquid.
 */
if (!window.__supportBlockLoaded) {
  window.__supportBlockLoaded = true;

  (function () {
    function initFooterSupport(root) {
      if (!root || root.dataset.fsInit === 'true') return;
      var cfgEl = root.querySelector('[data-fs-config]');
      if (!cfgEl || typeof Intl === 'undefined' || !Intl.DateTimeFormat) return;
  
      var cfg;
      try {
        cfg = JSON.parse(cfgEl.textContent);
      } catch (e) {
        return;
      }
      root.dataset.fsInit = 'true';
  
      var toNum = function (v) { return parseInt(v, 10) || 0; };
      var schedules = (cfg.schedules || []).map(function (s) {
        return { open: s.open.map(toNum), close: s.close.map(toNum), shift: toNum(s.shift) };
      });
      var holidays = cfg.holidays || [];
      var weekdays = cfg.weekdays || [];
      var str = cfg.strings || {};
      var modules = root.querySelectorAll('[data-fs-module]');
  
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function fmtTime(m) { return pad(Math.floor(m / 60)) + ':' + pad(m % 60); }
      function isHoliday(iso) { return holidays.indexOf(iso) !== -1; }
  
      // Butikkens tid, uanset hvilken tidszone kunden sidder i.
      function nowInCopenhagen() {
        var parts = {};
        new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Copenhagen',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        }).formatToParts(new Date()).forEach(function (part) { parts[part.type] = part.value; });
  
        var y = parseInt(parts.year, 10);
        var m = parseInt(parts.month, 10);
        var d = parseInt(parts.day, 10);
        var h = parseInt(parts.hour, 10) % 24;
        var mi = parseInt(parts.minute, 10);
        return {
          y: y, m: m, d: d,
          minutes: h * 60 + mi,
          wd: new Date(Date.UTC(y, m - 1, d)).getUTCDay(),
          iso: parts.year + '-' + parts.month + '-' + parts.day
        };
      }
  
      function dayAhead(base, offset) {
        var dt = new Date(Date.UTC(base.y, base.m - 1, base.d + offset));
        return { wd: dt.getUTCDay(), iso: dt.toISOString().slice(0, 10) };
      }
  
      // Skemaets eget vægur: butikkens tid plus skemaets forskydning i minutter.
      // Telefonerne vises i markedets tid (Finland/Estland = dansk tid + 1), mens
      // showroomet altid står i dansk tid, fordi det er et fysisk sted i Danmark.
      function contextFor(base, shift) {
        if (!shift) return base;
        var dt = new Date(Date.UTC(base.y, base.m - 1, base.d) + (base.minutes + shift) * 60000);
        return {
          y: dt.getUTCFullYear(), m: dt.getUTCMonth() + 1, d: dt.getUTCDate(),
          minutes: dt.getUTCHours() * 60 + dt.getUTCMinutes(),
          wd: dt.getUTCDay(),
          iso: dt.toISOString().slice(0, 10)
        };
      }
  
      function rangeText(sched, day) {
        if (isHoliday(day.iso) || !sched.close[day.wd]) return str.closedWord;
        return fmtTime(sched.open[day.wd] + sched.shift) + '–' + fmtTime(sched.close[day.wd] + sched.shift);
      }
  
      function nextOpenText(sched, now, today) {
        for (var i = 0; i <= 8; i++) {
          var day = i === 0 ? today : dayAhead(now, i);
          if (isHoliday(day.iso) || !sched.close[day.wd]) continue;
          if (i === 0 && now.minutes >= sched.open[day.wd] + sched.shift) continue;
  
          var label = i === 0 ? str.today : (i === 1 ? str.tomorrow : (weekdays[day.wd] || '').trim());
          return (str.next || '')
            .replace('[day]', label)
            .replace('[time]', fmtTime(sched.open[day.wd] + sched.shift));
        }
        return '';
      }
  
      function render() {
        var base = nowInCopenhagen();
  
        Array.prototype.forEach.call(modules, function (module) {
          var sched = schedules[parseInt(module.dataset.fsModule, 10)];
          if (!sched) return;
  
          var now = contextFor(base, sched.shift);
          var today = { wd: now.wd, iso: now.iso };
          var tomorrow = dayAhead(now, 1);
  
          var isOpen = !isHoliday(today.iso) &&
            sched.close[today.wd] > 0 &&
            now.minutes >= sched.open[today.wd] + sched.shift &&
            now.minutes < sched.close[today.wd] + sched.shift;
  
          var statusEl = module.querySelector('[data-fs-status]');
          var statusTextEl = module.querySelector('[data-fs-status-text]');
          if (statusEl && statusTextEl) {
            statusEl.classList.toggle('footer-support__status--closed', !isOpen);
            statusTextEl.textContent = isOpen
              ? statusEl.dataset.fsOpenLabel
              : statusEl.dataset.fsClosedLabel;
          }
  
          var dailyEl = module.querySelector('[data-fs-daily]');
          if (dailyEl) {
            dailyEl.textContent = str.todayCap + ' ' + rangeText(sched, today) +
              ' · ' + str.tomorrowCap + ' ' + rangeText(sched, tomorrow);
          }
  
          var nextEl = module.querySelector('[data-fs-next]');
          if (nextEl) {
            var text = isOpen ? '' : nextOpenText(sched, now, today);
            nextEl.textContent = text;
            nextEl.classList.toggle('is-hidden', text === '');
          }
        });
      }
  
      // En badge, der er knækket ned under navnet (langt afdelingsnavn på en smal skærm),
      // ser forkert ud højrestillet alene på sin linje. Marker den, så CSS kan stille den
      // til venstre - på samme linje som navnet flugter den stadig til højre.
      function markWrappedBadges() {
        Array.prototype.forEach.call(root.querySelectorAll('.footer-support__head'), function (head) {
          var badge = head.querySelector('.footer-support__status');
          var label = head.querySelector('.footer-support__label, .footer-support__chat');
          if (!badge || !label) return;
          var wrapped = badge.getBoundingClientRect().top - label.getBoundingClientRect().top > 8;
          head.classList.toggle('is-wrapped', wrapped);
        });
      }

      function renderAndLayout() {
        render();
        markWrappedBadges();
      }

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(markWrappedBadges, 100);
      });

      renderAndLayout();
      // Siden kan ligge åben over en åbne-/lukketid.
      setInterval(renderAndLayout, 60000);
    }
  
    function initAll() {
      document.querySelectorAll('[data-footer-support]').forEach(initFooterSupport);
    }
  
    initAll();
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();
}
